import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the Item class to inform that the item should display a drilldown editor
 * @param {LayoutItem} Item The item to enhance
 */
export const withShowSkipButton: PresetHOC<{
    showSkipButton?: boolean;
}> = (Item) => {
    Item.showSkipButton = true;

    return Item;
};
